export enum MatchActionTypes {
  UPDATE_MATCH = 'UPDATE_MATCH'
}
